export default "__VITE_ASSET__fe21f734__"